// extracted by mini-css-extract-plugin
export default {"wrapper":"purchases_wrapper__+IoLS","navigation":"purchases_navigation__VMoJN","content":"purchases_content__Pc6c5","loader":"purchases_loader__2xTUP"};